import { Component, OnInit, Input } from '@angular/core';
import { MenuService } from '../menu.service';
import { Menu } from '../menu.model';
import { StripeResponseService } from 'src/app/services/stripe-response.service';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  providers: [MenuService]
})
export class VerticalMenuComponent implements OnInit {
  @Input('menuParentId') menuParentId = 0;
  public menuItems: Array<Menu> = [];
  constructor(public menuService: MenuService,
    public stripeResponseService: StripeResponseService) { }

  ngOnInit() {

    if (this.stripeResponseService.currentLoggedInUser === undefined) {
      this.getDefaultMenus();
    } else {
      this.getUserAllowedMenus();
    }


    this.stripeResponseService.messageLoginPlus.subscribe((message) => {
      this.getUserAllowedMenus();
    });

    this.stripeResponseService.messageLogoutPlus.subscribe((message) => {
      this.getDefaultMenus();
    });

    // let roles= this.stripeResponseService.currentLoggedInUser?.roles || null;

    // const entriesToArray = Object.entries(roles);

    // this.menuItems = this.menuService.getVerticalMenuItems();
    // this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
    // this.menuItems = this.menuItems.filter(menuItem => {
    //   const rolesAllowed = menuItem.roles;
    //   if (rolesAllowed !== undefined){
    //     let countAllowedRoles = this.getAllowedRoles(rolesAllowed, entriesToArray);
    //     let allowed = countAllowedRoles !== 0;
    //     return allowed;
    //   } else if (rolesAllowed === undefined){
    //     return true;
    //   } else {
    //     return false;
    //   }
    // });
  }

  onClick(menuId: number) {
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuService.getVerticalMenuItems(), menuId);
  }
  public getAllowedRoles(rolesAllowed: any[], entriesToArray: any[]): number {

    const foundArray: any[] = [];
    rolesAllowed.forEach((ra: any) => {
      entriesToArray.filter(([key, value]: any) => {

        if (key === ra && value === true) {
          foundArray.push(ra);
          return ra;
        }

      });
    });

    if (foundArray.length > 0) {
      console.log('found');
      console.log('foundArray', foundArray);
    } else {
      console.log('No items matched');
    }

    return foundArray.length;

  }

  getDefaultMenus() {

    const roles: any[] = [];

    if (roles === null) {
      alert("no roles assigned.");
      return false;
    } else {

      const entriesToArray = Object.entries(roles);
      console.log('entriesToArray', entriesToArray);
  
      this.menuItems = this.menuService.getVerticalMenuItems();
      this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
      this.menuItems = this.menuItems.filter(menuItem => {
        const rolesAllowed = menuItem.roles;
        if (rolesAllowed !== undefined) {
          const countAllowedRoles = this.getAllowedRoles(rolesAllowed, entriesToArray);
          const allowed = countAllowedRoles !== 0;
          return allowed;
        } else if (rolesAllowed === undefined) {
          return true;
        } else {
          return false;
        }
      });
    }

    return false;

  }

  getUserAllowedMenus() {

    // let roles = {
    //   admir:false,
    //   areaManager: false,
    //   branchManager: false,
    //   teamLeader: false,
    //   companyManager: false,
    //   subscriber: true
    // };

    const roles = this.stripeResponseService.currentLoggedInUser?.roles || null;

    if (roles === null) {
      alert("no roles assigned.");
      return false;
    }
    else {
      const entriesToArray = Object.entries(roles);
      console.log('entriesToArray', entriesToArray);

      this.menuItems = this.menuService.getVerticalMenuItems();
      this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
      this.menuItems = this.menuItems.filter(menuItem => {
        const rolesAllowed = menuItem.roles;
        if (rolesAllowed !== undefined) {
          const countAllowedRoles = this.getAllowedRoles(rolesAllowed, entriesToArray);
          const allowed = countAllowedRoles !== 0;
          return allowed;
        } else if (rolesAllowed === undefined) {
          return true;
        } else {
          return false;
        }
      });
    }

    return false;
  }
}
